import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@vaiu/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
        outline: "text-foreground",
        success:
          "border-emerald-200/90 bg-emerald-50 text-emerald-900 shadow-none hover:bg-emerald-100/90 dark:border-emerald-800/60 dark:bg-emerald-950/45 dark:text-emerald-50 dark:hover:bg-emerald-950/70",
        info:
          "border-sky-200/90 bg-sky-50 text-sky-950 shadow-none hover:bg-sky-100/80 dark:border-sky-800/60 dark:bg-sky-950/45 dark:text-sky-50 dark:hover:bg-sky-950/70",
        warning:
          "border-amber-200/90 bg-amber-50 text-amber-950 shadow-none hover:bg-amber-100/80 dark:border-amber-800/60 dark:bg-amber-950/45 dark:text-amber-50 dark:hover:bg-amber-950/70",
        muted:
          "border-border/80 bg-muted text-muted-foreground shadow-none hover:bg-muted/90",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge, badgeVariants }
